import React from 'react';

export default function notFound() {

    return (
        <h1>404</h1>
    )
}